// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoMetas_CalculaDiasUteisResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * PlanoMetas CalculaDiasUteis Response Contract
 *
 * Response for POST /plano_metas/calcula_dias_uteis - Calculate business days
 *
 * @package Contracts
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface PlanoMetas_CalculaDiasUteisResponseDados {
dias_uteis: number
}

export type PlanoMetas_CalculaDiasUteisResponse = ApiResponse<PlanoMetas_CalculaDiasUteisResponseDados>;

registerResponseContract('PlanoMetas_CalculaDiasUteisResponse', {
  dias_uteis: { type: 'number',  required: true },
})
